export const stringToBool = (value, defaultValue) => {
  switch (value) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return defaultValue;
  }
};
